module.exports = {
      id: "palo-bangla-usage",
      viewBox: "0 0 230 55",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#palo-bangla",
      toString: function () {
        return this.url;
      }
    }